import PropTypes from 'prop-types';
import { ContentsProps, ContentsDefaults } from './contents';
import { PeriodsProps, PeriodsDefaults } from './periods';

export const FacilityProps = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  agency: PropTypes.string,
  lat_long: PropTypes.shape({
    lat: PropTypes.string,
    long: PropTypes.string
  }),
  state: PropTypes.string,
  no_fee_periods: PeriodsProps,
  contents: ContentsProps
});

export const FacilityDefaults = {
  id: null,
  name: "",
  agency: "",
  lat_long: {
    lat: '0',
    long: '0'
  },
  state: "",
  no_fee_periods: PeriodsDefaults,
  contents: ContentsDefaults
};
